<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #SectorForm="ngForm" novalidate>
    <accordion>
      <accordion-group [isOpen]="isOpen" (isOpenChange)="isOpen = $event">
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i class="fa" [ngClass]="isOpen ? 'fa-minus' : 'fa-plus'"></i
          ></span>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div class="form-group row">
                <label for="sectorStatus" class="col-md-3">
                  <small>{{ "status" | translate }}</small>
                </label>
                <div class="col-9">
                  <p-dropdown
                    [disabled]="isReadOnly"
                    [options]="[
                      { label: 'ACTIVE' | translate, value: 'ACTIVE' },
                      { label: 'PASSIVE' | translate, value: 'PASSIVE' }
                    ]"
                    [(ngModel)]="entity.status"
                    (onChange)="formChange(true)"
                    name="sectorStatus"
                    id="sectorStatus"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="sectorCode" class="col-3">
                  <small>
                    {{ "code" | translate }} <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-9 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      #sectorCode="ngModel"
                      name="sectorCode"
                      [disabled]="isReadOnly"
                      [ngClass]="
                        alertShow && sectorCode.invalid ? 'errorInput' : ''
                      "
                      [(ngModel)]="entity.code"
                      (ngModelChange)="formChange(true)"
                      id="sectorCode"
                      maxlength="10"
                      required
                    />
                    <div
                      class="input-group-append"
                      (click)="!isReadOnly ? generateCode() : ''"
                    >
                      <span
                        class="input-group-text transparent code-icon"
                        id="basic-addon2"
                      >
                        <i
                          [hidden]="!generateCodeSpin"
                          class="fa fa-spinner fa-spin fa-fw"
                        ></i>
                        <img
                          [hidden]="generateCodeSpin"
                          src="assets/img/keys.svg"
                          style="width: 19px"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="alertShow && sectorCode.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3">
                  <label for="sectorName">
                    <small
                      >{{ "description" | translate }}
                      <i class="text-danger">*</i></small
                    >
                  </label>
                </div>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="sectorName"
                    #sectorName="ngModel"
                    #focusElement
                    [disabled]="isReadOnly"
                    [ngClass]="
                      alertShow && sectorName.invalid ? 'errorInput' : ''
                    "
                    [(ngModel)]="entity.description"
                    (ngModelChange)="formChange(true)"
                    id="sectorName"
                    maxlength="50"
                    required
                  />
                  <div
                    *ngIf="alertShow && sectorName.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
